/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExistingOpenChatsListRequest } from '../models/ExistingOpenChatsListRequest';
import type { ListCreationRequest } from '../models/ListCreationRequest';
import type { ListCreationResponse } from '../models/ListCreationResponse';
import type { ListProcessStatus } from '../models/ListProcessStatus';
import type { NewOpenChatsListRequest } from '../models/NewOpenChatsListRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DashboardListCreationRestControllerService {
    /**
     * @returns ListCreationResponse OK
     * @throws ApiError
     */
    public static createNewOpenChatsList({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: NewOpenChatsListRequest,
    }): CancelablePromise<ListCreationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/lists/{creatorId}/open-chats/new',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ListCreationResponse OK
     * @throws ApiError
     */
    public static createExistingOpenChatsList({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ExistingOpenChatsListRequest,
    }): CancelablePromise<ListCreationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/lists/{creatorId}/open-chats/existing',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ListCreationResponse OK
     * @throws ApiError
     */
    public static lowSpenderList({
        creatorId,
        from,
        to,
        requestBody,
        spendLimit = 50,
    }: {
        creatorId: number,
        from: string,
        to: string,
        requestBody: ListCreationRequest,
        spendLimit?: number,
    }): CancelablePromise<ListCreationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/lists/{creatorId}/new-subscriber/low-spender-list',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'spendLimit': spendLimit,
                'from': from,
                'to': to,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ListCreationResponse OK
     * @throws ApiError
     */
    public static highSpenderList({
        creatorId,
        from,
        to,
        requestBody,
        spendLimit = 100,
    }: {
        creatorId: number,
        from: string,
        to: string,
        requestBody: ListCreationRequest,
        spendLimit?: number,
    }): CancelablePromise<ListCreationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/lists/{creatorId}/new-subscriber/high-spender-list',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'spendLimit': spendLimit,
                'from': from,
                'to': to,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ListCreationResponse OK
     * @throws ApiError
     */
    public static createLinkList({
        creatorId,
        linkId,
        requestBody,
    }: {
        creatorId: number,
        linkId: number,
        requestBody: ListCreationRequest,
    }): CancelablePromise<ListCreationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/lists/{creatorId}/link/{linkId}',
            path: {
                'creatorId': creatorId,
                'linkId': linkId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ListProcessStatus OK
     * @throws ApiError
     */
    public static getListProcessStatus({
        creatorId,
        listId,
    }: {
        creatorId: number,
        listId: number,
    }): CancelablePromise<ListProcessStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/lists/{creatorId}/{listId}/status',
            path: {
                'creatorId': creatorId,
                'listId': listId,
            },
        });
    }
}
